import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { getErrorMessage } from "../functions/errors.functions";
import { AuthRequest } from "../models/requests/auth.request";
import { UserDataModel } from "../models/user-data.model";
import { IdentityService } from "./identity.service";
import { RestService } from "./rest.service";


@Injectable()
export class AuthenticateService {

  tokenError: string;

  constructor(
    private identityService: IdentityService,
    private restService: RestService,
    private translateService: TranslateService,
  ) {
    this.tokenError = this.translateService.instant('commons.errors.missingToken');
  }

  /**
   * ## Authenticate Service Validate User Function
   * Send to backend the Web Json Token [JWT] given by `Cloudflare Access` engine.
   * @returns Promise void
   */
  public async validateUser(): Promise<void> {
    try {
      const token = this.identityService.getToken();
      if (!token) {
        return Promise.reject(new Error(this.tokenError));
      }
      const request = new AuthRequest(token);
      const user = await this.restService.post<UserDataModel>('authenticate', request);
      this.identityService.setUser(user);
      return Promise.resolve();
    }
    catch (error) {
      return Promise.reject(new Error(getErrorMessage(error)));
    }
  }

}
